import { useCallback } from "react";
import type { ActivationProgressPayload } from "./types";
import { getActivationRun } from "./runStore";

interface UseActivationProgressReporterArgs {
    authAxios?: {
        post: (url: string, body?: any, config?: any) => Promise<any>;
    } | null;
    getToken?: (() => string | null | undefined) | null;
}

export const useActivationProgressReporter = ({
    authAxios,
    getToken,
}: UseActivationProgressReporterArgs) => {
    const reportActivationProgress = useCallback(
        (payload: ActivationProgressPayload) => {
            if (!authAxios) return;
            const token = getToken?.();
            const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
            void authAxios
                .post("/activation/runs/progress", payload, { headers })
                .catch((error: any) => {
                    console.warn("[ActivationTelemetry] Failed to report progress", error);
                });
        },
        [authAxios, getToken]
    );

    const reportActivationTrialStarted = useCallback(
        (runId: string | null | undefined) => {
            const safeRunId = String(runId || "").trim();
            if (!safeRunId) return;

            const run = getActivationRun(safeRunId);
            if (!run?.flowId) return;
            reportActivationProgress({
                runId: safeRunId,
                flowId: run?.flowId,
                status: "completed",
                currentStepIndex: Math.max(0, Number(run?.currentStepIndex ?? 0)),
                currentStepId: undefined,
                source: run?.source,
                projectId: run?.projectId,
                trialStarted: true,
            });
        },
        [reportActivationProgress]
    );

    return {
        reportActivationProgress,
        reportActivationTrialStarted,
    };
};

export default useActivationProgressReporter;
